import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
/** Rich note title line; shell styles (`.block-view.card--note`) are in block-view.scss. */
export const NoteBlockContent = memo(({ block }) => {
    const label = block.title || "Note";
    return (_jsx("div", { className: "card-content", children: _jsx("span", { className: "light-text", children: label }) }));
});
